<template>
  <div>
    <div class="block-code-wrap flex-row-center">
      <p class="label"><em>*</em>激活码</p>
      <div class="block-right flex-row">
        <!-- <el-select v-model="activeCode" filterable placeholder="请选择激活码" v-if="fAgentLevel ===2">
          <el-option :value="id" :label="id" v-for="(id,index) in list" :key="index"></el-option>
        </el-select> -->
        <el-input v-model="activeCode" placeholder="请输入激活码"></el-input>
        <!-- <p class="tips" v-if="fAgentLevel ===2">激活码（{{list.length}}）</p> -->
      </div>
    </div>
    <div class="block-next flex-row-center">
      <el-button type="primary" class="btn-next" @click="handlerCode">下一步</el-button>
    </div>
  </div>
</template>

<script>
import { activeCodeList } from '@/api/merchant-info'
export default {
  data () {
    return {
      activeCode: '',
      fAgentLevel: 0,
      list: []
    }
  },
  mounted () {
    const userInfo = this.$store.state.user.userInfo.userEntity
    this.fAgentLevel = userInfo.fAgentLevel
    // if (this.fAgentLevel === 2) {
    //   this.activeCodeList()
    // }
  },
  methods: {
    handlerCode () {
      this.$emit('handlerCode', this.activeCode)
    },
    async activeCodeList () {
      try {
        const res = await activeCodeList()
        this.list = res.data.list
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
.block-right{
  align-items: center;
  .tips{
    margin:0 0 0 10px;
  }
}
.block-code-wrap{
  padding:120px 0 0 0;
  .label{
    padding:0 20px 0 0;
    em{
      color: red;
      font-style: normal;
      padding:0 4px 0 0;
    }
  }
}
.block-next{
  margin:40px 0 0 0;
  .btn-next{
    width:240px;
  }
}
</style>
